import { render } from "./SignUpConfirmPhone.vue?vue&type=template&id=5896b7d5&scoped=true"
import script from "./SignUpConfirmPhone.vue?vue&type=script&lang=js"
export * from "./SignUpConfirmPhone.vue?vue&type=script&lang=js"

import "./SignUpConfirmPhone.vue?vue&type=style&index=0&id=5896b7d5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5896b7d5"]])

export default __exports__